import React, { Component } from "react";
import Skip from "../../pageElements/skip";
import Header from "../../pageElements/header";
import Main from "../../containers/main";
import Footer from "../../pageElements/footer";
import { CircleArrow as ScrollUpButton } from "react-scroll-up-button";
import FlexText from "../../flexText";
import ColMaker from "./colMaker";
import "./styles/css/basicPage.css";
class BasicPage extends Component {
  render() {
    const {
      menu,
      og_group_ref,
      field_boolean_1,
      token,
      title,
      nid,
      footer,
      field_column_items,
      field_header_media,
      field_page_layout,
      field_media_bands,
    } = this.props.page;
    return (
      <div
        id="page"
        className="App"
        style={{
          height: "100%",
          minHeight: "100%",
        }}
      >
        <Skip />
        <Header
          display="block"
          group={og_group_ref}
          menu={menu}
          token={token}
        />
        <Main
          className="basic page"
          margin={
            field_boolean_1 === "1" ? "125px auto 0 auto" : "125px auto 0 auto"
          }
        >
          {typeof title !== "undefined" ? (
            <FlexText
              max="30"
              min="30"
              pert=".25"
              classes="flextext"
              tag="h1"
              color="#01533F"
              styles={{
                fontFamily: "Roboto",
                textAlign: "left",
                lineHeight: "40px",
                fontWeight: "400",
                margin: "0 8px",
                padding: "0.5em 0",
              }}
            >
              {title}
            </FlexText>
          ) : null}
          <ColMaker
            nid={nid}
            token={token}
            col="left"
            header={
              typeof field_header_media !== "undefined"
                ? field_header_media[0]
                : null
            }
            rows={field_media_bands}
            layout={field_page_layout}
            style={{
              marginBottom: "48px",
            }}
          />
          {typeof field_column_items != "undefined" ? (
            <ColMaker
              nid={nid}
              col="right"
              rows={field_column_items}
              layout={field_page_layout}
              token={token}
            />
          ) : null}
        </Main>
        {typeof footer.body !== "undefined" ? (
          <Footer>{footer.body}</Footer>
        ) : (
          "The University of Vermont &copy; 2019"
        )}

        <ScrollUpButton
          style={{
            backgroundColor: "#898989",
            border: "5px solid #898989",
            fill: "#fff",
            height: "30px",
            width: "30px",
          }}
        />
      </div>
    );
  }
}

export default BasicPage;
